import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import PCContainer from "../../components/atoms/layout/pcContainer";

import useDisplay from "../../hooks/useDisplay";
import { route } from "../../router/route";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import TitleInput from "../../components/molecules/input/titleInput";
import MainBtn from "../../components/atoms/button/mainBtn";
import { errorHandler } from "../../util/errorHandler";
import { toast } from "react-toastify";
import AuthApi from "../../api/auth.api";

const PwChange = () => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const location = useLocation();
  const { phone, account, smsVerificationToken } = location.state || {};

  const navigate = useNavigate();

  const [pw, setPw] = useState("");
  const [pwErrorM, setPwErrorM] = useState("");
  const [pwConfirm, setPwConfirm] = useState("");
  const [pwConfirmErrorM, setPwConfirmErrorM] = useState("");

  useEffect(() => {
    if (!phone || !account || !smsVerificationToken) {
      navigate(route.pw_find, { replace: true });
    }
  }, [phone, account, smsVerificationToken]);

  useEffect(() => {
    if (pw.length > 0) {
      const regType1 =
        /^(?=.*[A-Za-z])(?=.*\d|(?=.*[!@#$%^&*(),.?":{}|<>]))|(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])/;

      if (!regType1.test(pw)) {
        return setPwErrorM("비밀번호 조합이 올바르지 않습니다.");
      }

      if (pw.length < 8) {
        return setPwErrorM("비밀번호 8자리 이상을 입력해주세요. ");
      }

      setPwErrorM("");
    }
  }, [pw]);

  useEffect(() => {
    if (pwConfirm.length > 0) {
      if (pwConfirm !== pw) {
        return setPwConfirmErrorM("비밀번호가 일치하지 않습니다.");
      }

      setPwConfirmErrorM("");
    }
  }, [pwConfirm]);

  const handleResetPw = async () => {
    try {
      const obj01 = {
        phoneNumber: phone,
        smsVerificationToken,
      };

      const reponse = await AuthApi.pwFind(obj01);

      const obj02 = {
        resetPwToken: reponse.data.data.resetPwToken,
      };

      await AuthApi.pwReset(account, pw, obj02);
      toast("비밀번호 재설정이 완료되었습니다.");
      navigate(route.login);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <PwChangeSection>
        <PCContainer
          style={{
            padding: isSmall ? "80px 20px 80px 20px" : "80px 0px 150px 0px",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: isMobile ? "100%" : 790,
              padding: isMobile
                ? "0px"
                : isTablet
                ? "60px 140px"
                : "60px 205px",
              boxShadow: isMobile ? "none" : "0px 0px 6px 0px #0000001A",
              borderRadius: isMobile ? 0 : 30,
            }}
          >
            <LSBdDisplay02
              style={{
                textAlign: "center",
                marginBottom: 4,
              }}
            >
              비밀번호 재설정
            </LSBdDisplay02>
            <LSRgH1HeadLine
              style={{
                textAlign: "center",
                marginBottom: 32,
                color: "#898E99",
              }}
            >
              {isMobile
                ? "비밀번호는 8자 이상 16자 이하의\n문자, 숫자, 특수기호 중\n2가지 이상을 조합하여 만들어야 합니다."
                : "비밀번호는 8자 이상 16자 이하의 문자, 숫자, 특수기호 중\n2가지 이상을 조합하여 만들어야 합니다."}
            </LSRgH1HeadLine>

            <TitleInput
              title={"비밀번호"}
              essential={true}
              placeholder={"비밀번호를 입력해 주세요."}
              type={"password"}
              onChange={(e) => {
                setPw(e.target.value);
              }}
              value={pw}
              warningMessage={pwErrorM}
              style={{
                marginBottom: isMobile ? 24 : 28,
              }}
            />

            <TitleInput
              title={"비밀번호 확인"}
              essential={true}
              placeholder={"비밀번호를 입력해 주세요."}
              type={"password"}
              onChange={(e) => {
                setPwConfirm(e.target.value);
              }}
              value={pwConfirm}
              warningMessage={pwConfirmErrorM}
              style={{
                marginBottom: isMobile ? 24 : 20,
              }}
            />

            <MainBtn
              disabled={
                pw && pwConfirm && pwErrorM === "" && pwConfirmErrorM === ""
                  ? false
                  : true
              }
              onClick={() => {
                handleResetPw();
              }}
              style={{
                marginTop: 8,
              }}
            >
              <LSRgH1HeadLine
                style={{
                  color: "#FFFFFF",
                  textAlign: "center",
                }}
              >
                비밀번호 재설정하기
              </LSRgH1HeadLine>
            </MainBtn>
          </div>
        </PCContainer>
      </PwChangeSection>
    </>
  );
};

export default PwChange;

const PwChangeSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;
